
// ===============================
// API CLIENT (src/api/client.js)
// ===============================

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:8000';

const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor pro přidání JWT tokenu do requestů
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);
// src/api/client.js - upravený interceptor
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        // Předčasný návrat pro síťové chyby bez response
        if (!error || !error.response) {
            console.error('Network error without response:', error);
            return Promise.reject(error);
        }

        const originalRequest = error.config;

        // Kontrola, zda se jedná o 401 a zda požadavek nebyl již znovu odeslán
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            // DŮLEŽITÉ: Ochrana proti zacyklení
            // Pokud se jedná o požadavek na refresh tokenu, nebudeme ho znovu posílat
            if (originalRequest.url && originalRequest.url.includes('/api/auth/refresh')) {
                localStorage.removeItem('token');
                //localStorage.removeItem('refreshToken');
                window.location.href = '/login';
                return Promise.reject(error);
            }

            localStorage.removeItem('token');
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
            return Promise.reject("error");
/*
            try {
                const refreshToken = localStorage.getItem('refreshToken');
                if (!refreshToken) {
                    throw new Error('No refresh token available');
                }

                // Důležité: Použití základního axios místo apiClient
                // aby se předešlo zachycení v interceptoru
                const response = await axios.post(`${API_URL}/api/auth/refresh`, { refreshToken });

                if (!response || !response.data || !response.data.token) {
                    throw new Error('Invalid refresh token response');
                }

                localStorage.setItem('token', response.data.token);
                originalRequest.headers.Authorization = `Bearer ${response.data.token}`;

                return axios(originalRequest);
            } catch (refreshError) {
                localStorage.removeItem('token');
                //localStorage.removeItem('refreshToken');

                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }

                return Promise.reject(refreshError);
            }*/
        }

        return Promise.reject(error);
    }
);

export default apiClient;